import { render } from "./BaseButton.vue?vue&type=template&id=46c024ab&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=46c024ab&lang=scss&scoped=true"

import exportComponent from "/var/www/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c024ab"]])

export default __exports__